import { enqueueSnackbar, SnackbarOrigin, VariantType } from 'notistack';

interface ISnackbarOptions {
  severity?: VariantType;
  anchorOrigin?: SnackbarOrigin;
  closeButton?: boolean;
}

export interface ISnackbarHook {
  showSnackbar(): void;
}

export const showSnackbar = (message: string, options?: ISnackbarOptions) => {
  const variant = options?.severity || 'default';
  const anchorOrigin = options?.anchorOrigin || {
    vertical: 'top',
    horizontal: 'right',
  };

  enqueueSnackbar(message, {
    ...options,
    variant,
    anchorOrigin,
  });
};
